export default __webpack_public_path__ + "static/chrisKitten-9e7e56a5065824d5638a2d9acefdd194.png";